/* eslint-disable @typescript-eslint/naming-convention */
import { Camera } from '@awesome-cordova-plugins/camera/ngx';
import { File } from '@awesome-cordova-plugins/file/ngx';
import { Network } from '@awesome-cordova-plugins/network/ngx';
import { FileTransfer } from '@awesome-cordova-plugins/file-transfer/ngx';
// import { OneSignal } from '@awesome-cordova-plugins/onesignal/ngx';
import { Toast } from '@awesome-cordova-plugins/toast/ngx';
import { Geolocation } from '@awesome-cordova-plugins/geolocation/ngx';
import { Keyboard } from '@awesome-cordova-plugins/keyboard/ngx';
// import { Device } from '@awesome-cordova-plugins/device/ngx';
// import { Device } from '@capacitor/device';
// import { DatePicker } from '@awesome-cordova-plugins/date-picker/ngx';
import { InAppBrowser } from '@awesome-cordova-plugins/in-app-browser/ngx';
import { StatusBar } from '@awesome-cordova-plugins/status-bar/ngx';
import { SplashScreen } from '@awesome-cordova-plugins/splash-screen/ngx';
// import { AppVersion } from '@awesome-cordova-plugins/app-version/ngx';
// import { AppVersion } from '@awesome-cordova-plugins/app-version'; // /app-version/ngx';
import { BatteryStatus } from '@awesome-cordova-plugins/battery-status/ngx';
// import { OneSignal } from '@awesome-cordova-plugins/onesignal/ngx';
import { NavParams } from '@ionic/angular';
import { Dialogs } from '@awesome-cordova-plugins/dialogs/ngx';
import { Contacts } from '@awesome-cordova-plugins/contacts/ngx';
// import { Contacts } from '@awesome-cordova-plugins/contacts';
// import { NativeGeocoder, NativeGeocoderReverseResult, NativeGeocoderForwardResult  } from '@awesome-cordova-plugins/native-geocoder';
// import {AppRate} from '@awesome-cordova-plugins/app-rate';

/**
 * Created by ashok on 02/05/17.
 */
export const NativeProviders = [
  // AppVersion,
  Camera,
  File,
  Network,
  FileTransfer,
  Geolocation,
  Dialogs,
  // OneSignal,
  Toast,
  Keyboard,
  // Device,
  InAppBrowser,
  // DatePicker,
  StatusBar,
  SplashScreen,
  BatteryStatus,
  NavParams,
  Contacts,
];
